import { Api, IApiResponse } from '../api';
import { UserPreferencesDto } from '../models';

export const get = (signal?: AbortSignal, accessToken?: string): Promise<IApiResponse<UserPreferencesDto>> =>
    Api.get('user-preferences/me', signal, accessToken);

export const update = (userPreferences: UserPreferencesDto, signal?: AbortSignal, accessToken?: string) =>
    Api.put('user-preferences/me', userPreferences, signal, undefined, accessToken);

export const reset = (signal?: AbortSignal, accessToken?: string) => Api.delete('user-preferences/me', undefined, signal, accessToken);
